module.exports = __webpack_public_path__ + "img/Sri Lanka.643002a1.svg";